<script>
export default {
  name: "TemplateView",
  computed: {
    selectedRole() {
      return localStorage.getItem("selected_role") || "default";
    },
  },
  mounted() {
    this.$router.push({ name: this.selectedRole });
  },
};
</script>

<template>
  <div></div>
</template>
